<template>
    <v-app>
        <div class="card card-custom">
            <div class="card-body p-0">
                <div
                        class="wizard wizard-2"
                        id="kt_wizard_v2"
                        data-wizard-state="step-first"
                        data-wizard-clickable="true"
                >
                    <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">
                        <!--begin: Wizard Form-->
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12">
                                <h4>
                                    <span> Manage Lessons</span>
                                </h4>
                                <router-link :to="{name:'dashboard'}">
                                    Dashboard
                                </router-link>
                                \
                                <router-link :to="{name:'syllabus'}">
                                    Syllabus
                                </router-link>
                                \
                                Lessons

                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12 text-right">
                                <a @click="__add" class="btn btn-primary text-white mr-2">

                                    Add Lesson
                                </a>


                            </div>
                        </div>
                        <div class="row">
                            <form @submit.prevent="__get" class="row mt-5 mb-5 bg-filter">
                                <div class="col-3">
                                    <v-text-field label="Title"
                                                  type="text"
                                                  dense
                                                  outlined
                                                  v-model="search.title"/>
                                </div>
                                <div class="col-4">
                                    <v-select label="Status" outlined dense :items="active_statuses" item-text="title"
                                              item-value="value"
                                              v-model="search.active"></v-select>
                                </div>
                                <div class="col-4">
                                    <button class="btn btn-primary" @click="__get">Search</button>
                                </div>
                            </form>
                            <table class="table mt-3">
                                <thead class="text-left">
                                <th>Title</th>
                                <th>Description</th>
                                <th>Syllabus</th>
                                <th>Topic</th>
                                <th>Action</th>
                                </thead>

                                <draggable v-if="lessons.length" @change="sort" v-model="lessons" class="text-left"
                                           tag="tbody" handle=".handle">
                                    <tr v-for="(lesson, index) of lessons" :key="lesson.id">
                                        <td scope="row">
                                            <i class="cursor-drag fas fa-sort handle pr-2"></i>
                                            <a href="#" @click="__edit(lesson.id)" class="mr-2"> {{ lesson.title }}</a>
                                            <i class="fas fa-circle"
                                               :class="lesson.is_active?'dot-active':'dot-inactive'"></i>
                                        </td>
                                        <td>
                                            <p v-html="lesson.description ">
                                            </p>
                                        </td>

                                        <td  v-if="lesson.syllabus">
                                            {{ lesson.syllabus.title }}
                                        </td>
                                        <td  v-if="lesson.topic">
                                            {{ lesson.topic.title }}
                                        </td>


                                        <td>
                                            <b-dropdown
                                                    size="sm"
                                                    variant="link"
                                                    toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                                                    no-caret
                                                    right
                                                    no-flip
                                            >
                                                <template v-slot:button-content>
                                                    <slot>
                                                        <span>
                                                                    <i class="flaticon-more-1"></i>
                                                                  </span></slot>
                                                </template>
                                                <!--begin::Navigation-->
                                                <div class="navi navi-hover ">

                                                    <!--                                                  <b-dropdown-text tag="div" class="navi-item">-->
                                                    <!--                                                    <a href="#" class="navi-link" @click="detail(lesson.id)">-->
                                                    <!--                                                            <span class="navi-icon">-->
                                                    <!--                                                              <i class="fas fa-eye"></i>-->
                                                    <!--                                                            </span>-->
                                                    <!--                                                      <span class="navi-text"> View </span>-->
                                                    <!--                                                    </a>-->
                                                    <!--                                                  </b-dropdown-text>-->
                                                    <b-dropdown-text tag="div" class="navi-item">
                                                        <a href="#" class="navi-link" @click="__edit(lesson.id)">
                                                            <span class="navi-icon">
                                                              <i class="flaticon-edit"></i>
                                                            </span>
                                                            <span class="navi-text"> Edit </span>
                                                        </a>
                                                    </b-dropdown-text>

                                                    <b-dropdown-text tag="div" class="navi-item">
                                                        <a href="#" class="navi-link"
                                                           @click="__delete(lesson.id)">
                                                            <span class="navi-icon">
                                                              <i class="fas fa-trash"></i>
                                                            </span>
                                                            <span class="navi-text">  Delete</span>
                                                        </a>
                                                    </b-dropdown-text>

                                                </div>
                                                <!--end::Navigation-->
                                            </b-dropdown>

                                        </td>
                                    </tr>
                                </draggable>

                            </table>
                        </div>
                        <div class="row">
                            <div class="col-12" v-if="total>perPage">
                                <b-pagination
                                        @input="__get"
                                        v-model="page"
                                        :total-rows="total"
                                        :per-page="perPage"
                                        first-number
                                        last-number
                                ></b-pagination>
                                <!--  -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <create-and-update ref="lesson" @refresh_lesson="__get"></create-and-update>
        </div>
    </v-app>
</template>
<script>

    import {SiteSettingMixin} from "@/mixins/SiteSettingMixin";
    import CreateAndUpdate from "./CreateAndUpdate";
    import draggable from 'vuedraggable'
    import LessonsService from "@/core/services/lesson-planner/lessons/LessonsService";
    const lessonService = new LessonsService();

    export default {
        name: "lessons",
        mixins: [SiteSettingMixin],
        display: "Table",
        order: 8,
        components: {
            CreateAndUpdate,
            draggable
        },
        data() {
            return {
                active_statuses: [
                    {title: 'Active', value: "active"},
                    {title: 'Inactive', value: "in_active"}
                ],
                lessons: [],
                page: null,
                perPage: null,
                total: null,
                search: {
                    active: "active",
                    is_parent: "null"
                },
                dragging: false
            };
        },
        computed: {
            topic_id() {
                return this.$route.params.topic_id;
            },
            syllabus_id() {
                return this.$route.params.syllabus_id;
            }
        },
        mounted() {
            this.__get();

        },
        methods: {
            __get() {
                lessonService
                    .paginate(this.topic_id,this.search)
                    .then(response => {
                        this.lessons = response.data.data;
                        this.page = response.data.meta.current_page;
                        this.total = response.data.meta.total;
                        this.perPage = response.data.meta.per_page;
                    })
                    .catch(error => {
                    });
            },
            __add() {
                this.$refs["lesson"].showModal();
            },
            __edit(id) {
                this.$refs["lesson"].showModal(id);
            },
            manageCategory() {
                this.$refs['manageCategory'].showModal();
            },

            __delete(id) {
                this.$confirm({
                    message: `Are you sure you want to delete this item?`,
                    button: {
                        no: "No",
                        yes: "Yes"
                    },
                    /**
                     * Callback Function
                     * @param {Boolean} confirm
                     */
                    callback: confirm => {
                        if (confirm) {
                            lessonService
                                .delete(this.topic_id,id)
                                .then(response => {
                                    this.__get();
                                })
                                .catch(error => {
                                    //console.log(error);
                                });
                        }
                    }
                });
            },
            sort() {
                lessonService.sort(this.lessons).then((res) => {
                    this.$snotify.success("Sorted");
                    this.__get()
                }).catch(err => {
                    this.$snotify.success("Sorted Error");
                })
            },
            detail(id) {
                this.$router.push({name: "lesson-photo", params: {id: id}});
            }
        }
    };
</script>
<style scoped>
    .buttons {
        margin-top: 35px;
    }
</style>
